import styled, { keyframes, css } from 'styled-components';

import {
  motionEasingEnter,
  motionEasingLeave,
  motionTimeNumberXXL,
  scale010,
  scale050,
  xdlColorBackground,
  xdlColorMarkerHighlightText,
} from '@xing-com/tokens';

const pauseMotionTime = 1500;
const motionTimeNumber = Number(motionTimeNumberXXL);
const totalMotionTime = motionTimeNumber * 2 + pauseMotionTime;
const totalMotionTimeMS = `${totalMotionTime}ms`;
const growAnimationEnd = `${(motionTimeNumber * 100) / totalMotionTime}%`;
const fadeAnimationEnd = `${(motionTimeNumber * 2 * 100) / totalMotionTime}%`;

const pulseAnimation = keyframes`
  0% {
    animation-timing-function: ${motionEasingLeave};
    opacity: 1;
    transform: translate3d(-50%, -50%, -1px) scale(0.8);
  }

  ${growAnimationEnd} {
    animation-timing-function: ${motionEasingEnter};
    opacity: 0.3;
    transform: translate3d(-50%, -50%, -1px) scale(2.6);
  }

  ${fadeAnimationEnd} {
    animation-timing-function: step-end;
    opacity: 0;
    transform: translate3d(-50%, -50%, -1px) scale(2.6);
  }
`;

type DiscoverBadgeProps = {
  $stopPulseAnimation: boolean;
};

// *** Components ***
export const DiscoverBadge = styled.span<DiscoverBadgeProps>`
  background: ${xdlColorMarkerHighlightText};
  border-color: ${xdlColorBackground};
  border-radius: 50%;
  border-style: solid;
  border-width: ${scale010};
  box-sizing: content-box;
  display: inline-flex;
  height: ${scale050};
  position: relative;
  transform-style: preserve-3d;
  width: ${scale050};

  &::after {
    animation-name: ${pulseAnimation};
    animation-duration: ${totalMotionTimeMS};
    animation-fill-mode: forwards;
    animation-iteration-count: 5;
    background-color: ${xdlColorMarkerHighlightText};
    border-radius: 50%;
    content: '';
    height: ${scale050};
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, -1px);
    width: ${scale050};

    ${({ $stopPulseAnimation }) =>
      $stopPulseAnimation &&
      css`
        animation: none;
      `}

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
`;
